var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"center"}},[_c('vs-tab',{attrs:{"label":"Reporte Asesores"}},[_c('div',[_c('reporteriaAsesorVue')],1)]),_c('vs-tab',{attrs:{"label":"Reporte Instituciones"}},[_c('div',[_c('reporteriaInstitucionVue')],1)]),_c('vs-tab',{attrs:{"label":"Reporte General"}},[_c('div',[_c('ReporteGeneral')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }